module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/WaitingPopover/images/footer_bg.bca3b941.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/containers/PlayersMatchingView/components/WaitingPopover/images/footer_bg.png
// module id = 2796
// module chunks = 11